"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ToyotaType_Regular_ttf_1 = require("../../assets/ToyotaFonts/ToyotaType-Regular.ttf");
const regular = {
    fontFamily: 'regular',
    src: `
    url(${ToyotaType_Regular_ttf_1.default}) format('truetype')
  `,
    unicodeRange: 
    // tslint:disable-next-line:max-line-length
    'U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF',
};
exports.default = regular;
//# sourceMappingURL=regular.js.map